module.exports = __webpack_public_path__ + "img/teaching-4.e57a8eb2.png";